export const teamDropdownI18nPl = {
    teams: "Zespoły",
    findTeamPlaceholder: "Znajdź zespół",
};
